import { createContext } from 'react';
import { Booking } from '../../booking/booking.model';

export type NextBookingType = {
    nextBookings: Booking[];
    updateNextBookings: () => void;
}

export const NextBookingContext = createContext<NextBookingType>(null);